import { render } from "./BoardSimplePieCircle.vue?vue&type=template&id=13853eef&scoped=true"
import script from "./BoardSimplePieCircle.vue?vue&type=script&lang=js"
export * from "./BoardSimplePieCircle.vue?vue&type=script&lang=js"

import "./BoardSimplePieCircle.vue?vue&type=style&index=0&id=13853eef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13853eef"],['__file',"src/components/h5/board/BoardSimplePieCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13853eef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13853eef', __exports__)) {
    api.reload('13853eef', __exports__)
  }
  
  module.hot.accept("./BoardSimplePieCircle.vue?vue&type=template&id=13853eef&scoped=true", () => {
    api.rerender('13853eef', render)
  })

}


export default __exports__